const removeDuplicates = arr => [...new Set(arr)];

const getPasteableStrings = event =>
  removeDuplicates(event.clipboardData.getData("Text").split(/[\t\n\r,]/))
    .map(str => str.trim().toUpperCase())
    .filter(e => e);

const isArrayOfStrings = arr =>
  arr && arr.every(ele => typeof ele === "string");

export { getPasteableStrings, isArrayOfStrings };
